function PhotosUploadUtil(height: number, width: number, img: any, file: any) {
  const canvas: HTMLCanvasElement = document.createElement("canvas");
  const ctx: any = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  const MAX_WIDTH: any = 800;
  const MAX_HEIGHT: any = 600;
  console.log(width + "            " + height);
  canvas.width = MAX_WIDTH;
  canvas.height = MAX_HEIGHT;
  const ctx1 = canvas.getContext("2d") as CanvasRenderingContext2D;
  ctx1.drawImage(img, 0, 0, MAX_WIDTH, MAX_HEIGHT);
  const newImage = canvas.toDataURL("image/jpeg");
  const blobBin = atob(newImage.split(",")[1]);
  const array = [];
  for (let i = 0; i < blobBin.length; i++) {
    array.push(blobBin.charCodeAt(i));
  }
  const newBlob = new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  const newFile: File = createFile(newBlob, file);
  //return this.getBase64(newFile);
  return newFile;
}

function createFile(image: any, file: any) {
  var rawfile = new File([image], file.name, {
    type: file.type,
    lastModified: new Date().getTime(),
  });
  return rawfile;
}

export const truncateFileName = (fileName?: string, maxLength: number = 50) => {
  if (!fileName) return "";
  if (fileName.length <= maxLength) return fileName;

  const charsToShow = maxLength - 3; // 3 chars for "..."
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);

  const start = fileName.slice(0, frontChars);
  const end = fileName.slice(-backChars);

  return `${start}...${end}`;
};

export default PhotosUploadUtil;
